var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Run test"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Run test_2",
    d: "M11.1617 4.83884L10.2186 5.78192C9.98154 6.01901 10.1501 6.41942 10.4821 6.41415L13.4219 6.41415C13.6327 6.41415 13.796 6.25083 13.796 6.04008V3.1002C13.7953 3.02665 13.7728 2.95496 13.7314 2.89417C13.69 2.83339 13.6315 2.78622 13.5633 2.75861C13.4951 2.731 13.4203 2.72419 13.3483 2.73904C13.2762 2.75388 13.2102 2.78972 13.1585 2.84204L12.2154 3.78512C9.88671 1.45639 6.11439 1.45639 3.78566 3.78512C3.23773 4.33305 2.81624 4.96529 2.53173 5.63967C2.32099 6.13492 2.67925 6.68285 3.21665 6.68285C3.50116 6.68285 3.77512 6.52479 3.88576 6.25609C4.09651 5.73977 4.42316 5.25506 4.83938 4.83884C6.58329 3.09493 9.4178 3.09493 11.1617 4.83884ZM12.7844 9.31715C12.4999 9.31715 12.2207 9.48048 12.1153 9.74391C11.894 10.2602 11.5779 10.7449 11.1617 11.1612C9.4178 12.9051 6.58329 12.9051 4.83938 11.1612L5.78246 10.2181C6.01955 9.981 5.85095 9.58058 5.51903 9.58585L2.57915 9.58585C2.36841 9.58585 2.20508 9.74918 2.20508 9.95993L2.20508 12.8998C2.2058 12.9727 2.2279 13.0438 2.26865 13.1043C2.3094 13.1648 2.36701 13.212 2.43432 13.24C2.50163 13.2681 2.5757 13.2757 2.64734 13.2621C2.71897 13.2484 2.78503 13.2141 2.83731 13.1632L3.78566 12.2149C6.11438 14.5436 9.88671 14.5436 12.2154 12.2149C12.7634 11.667 13.1849 11.0347 13.4694 10.3603C13.6801 9.86509 13.3218 9.31715 12.7844 9.31715Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunTest);
export default __webpack_public_path__ + "static/media/run-test.2c1d56b0b3fc96583556435e642a3960.svg";
export { ForwardRef as ReactComponent };